"use client";
import React from "react";
import {Box} from "@mui/material";
import {FilterSelectGroupProps} from "@/app/(pages)/(general)/(home)/components/filter/types/filter";
import {Field} from "@/components/form";
import {useTheme} from "@mui/material/styles";


export default function FilterSelectGroup({values, options}: FilterSelectGroupProps) {
    const theme = useTheme()

    const selects = [
        {id: "filter-car", name: "Car", placeholder: "انتخاب خودروها", options: options.carOptions},
        {id: "filter-company", name: "Company", placeholder: "انتخاب برندها", options: options.companyOptions},
        {id: "filter-section", name: "Section", placeholder: "انتخاب بخش‌ ها", options: options.sectionOptions},
    ];

    return (
        <>
            {selects.map(({id, name, placeholder, options}) => (
                <Box
                    id={id}
                    position="relative"
                    key = {name}
                    flexGrow={1}
                    height="100%"
                    width={{xs: "100%", sm: "10%", md: "15%"}}
                >
                    {values[name as keyof typeof values]?.length > 0 && (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            position="absolute"
                            top="-10px"
                            right="-10px"
                            bgcolor="primary.main"
                            color="common.white"
                            borderRadius="50%"
                            width={20}
                            height={20}
                            lineHeight={20}
                            fontSize={13}
                            fontWeight={500}
                            zIndex={1}
                        >
                            {values[name as keyof typeof values]?.length}
                        </Box >
                    )}

                    <Field.Select
                        sx={{
                            "&:hover": {
                                borderColor: theme.palette.primary.main,
                                borderWidth: 1.5,
                            },
                            "&:focus-within": {
                                borderColor: theme.palette.primary.main,
                                borderWidth: 1.5,
                            },
                            "&:focus": {
                                borderColor: theme.palette.primary.main,
                                borderWidth: 1.5,
                            },
                        }}
                        name = {name}
                        placeholder = {placeholder}
                        options = {options}
                        isMulti
                        image
                        inputSx = {{size: "small"}}
                        fullWidth
                    />
                </Box >
            ))}
        </>
    );
}
